<template>
  <div class="pageBAW">
    <XR-head titleText="我的BAW" :rightShow="true"></XR-head>    
    <div class="total balance" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">BAW总额</p>
      <p class="money">{{BAWInfo.Coin.toFixed(candyDecimal)}}</p>
    </div>

    <!-- <div class="total account-address" v-if="!loaded">
      <p class="title"></p>
      <p class="address" ref="JFTText">{{UserInfo.Purse}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div> -->
    
    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <!--
        <router-link to="/usercenter/BAWRecharge">
          <mu-list-item title="BAW充值" v-if="UserInfo.UserBs>0">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        -->
        <!-- <mu-divider shallowInset/>
        <router-link to="/usercenter/bawTransfer">
          <mu-list-item title="BAW转账">
            <mu-icon slot="left" value=":fa fa-transfer"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link> -->
        <!--<mu-divider shallowInset/>-->
        <router-link to="/usercenter/bawStream">
          <mu-list-item title="BAW查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../../../util/errorcode'
import siteconfig from '../../../../util/siteconfigCache'
export default {
  data() {
    return {
      loaded : true,
      UserInfo:{
        Purse:'',
        UserBs:''
      },
      BAWInfo:{
        Coin:0
      },
      siteConfig:{ MobileBgImage : '' }
    };
  },
  mounted :function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });

    this.$refs.XRtoast.load()
    
    this.getSiteInfo()
    this.getUserInfo()
    this.getBAWInfo()
  },
  methods: { 
    getSiteInfo: function () {
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
            siteconfig.addSiteconfig(res.Data)
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    getUserInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){        
          ths.UserInfo = res.Data;
        }
      });
    },
    getBAWInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/BawServer/GetBawAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/BAWActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.BAWInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.UserInfo.Purse
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
}
}
</script>
<style>
.pageBAW .total{
  background: white;
  padding: 20px 20px;
}
.pageBAW .total.balance{
  overflow: hidden;
 background: url('/static/us-top-xn.png');
  background-size: 100% 100%;
}
.pageBAW .title{
  line-height: 24px;
  font-size: 14px;
}
.pageBAW .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageBAW .total.balance .title{
  color:white;
}
.pageBAW .total.balance .money{
  color:white;
}


.pageBAW .sub-nav{
  background: white;
  margin-top: 10px;
}

.pageBAW .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 10px 0 20px;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageBAW .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/baw/net/baw.vue